import { BB_CO_BROWSE, BB_LIVE_ASSIST } from '@whitbread-eos/api';
import { formatAssetsUrl, formatIBAssetsUrl } from '@whitbread-eos/utils';
import Script from 'next/script';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function LiveAssistScriptEmbed(_ref) {
  var _ref$isInnBusinessCon = _ref.isInnBusinessContext,
    isInnBusinessContext = _ref$isInnBusinessCon === void 0 ? false : _ref$isInnBusinessCon;
  return _jsxs(_Fragment, {
    children: [_jsx(Script, {
      src: isInnBusinessContext ? formatIBAssetsUrl(BB_LIVE_ASSIST) : formatAssetsUrl(BB_LIVE_ASSIST),
      strategy: "lazyOnload",
      id: "liveassist-script"
    }), _jsx(Script, {
      src: isInnBusinessContext ? formatIBAssetsUrl(BB_CO_BROWSE) : formatAssetsUrl(BB_CO_BROWSE),
      strategy: "lazyOnload",
      id: "cobrowse-script"
    })]
  });
}